"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstanceStorage = exports.ComponentStorage = void 0;
var components_1 = require("../utils/components");
var ComponentStorage = /** @class */ (function () {
    function ComponentStorage() {
        this.definitions = [];
        // eslint-disable-next-line max-len
        this.definitionsByCtor = new Map();
        // eslint-disable-next-line max-len
        this.definitionsByName = new Map();
    }
    ComponentStorage.prototype.all = function () {
        return this.definitions.slice();
    };
    ComponentStorage.prototype.push = function (def) {
        this.definitions.push(def);
        this.definitionsByCtor.set(def.component, def);
        this.definitionsByName.set(def.name, def);
    };
    ComponentStorage.prototype.remove = function (def) {
        var index = this.definitions.indexOf(def);
        if (index !== -1) {
            this.definitions.splice(index, 1);
        }
        this.definitionsByCtor.delete(def.component);
        this.definitionsByName.delete(def.name);
    };
    // eslint-disable-next-line max-len
    ComponentStorage.prototype.findByCtor = function (ctor) {
        return this.definitionsByCtor.get(ctor) || null;
    };
    ComponentStorage.prototype.findByName = function (name) {
        return this.definitionsByName.get(name) || null;
    };
    return ComponentStorage;
}());
exports.ComponentStorage = ComponentStorage;
var InstanceStorage = /** @class */ (function () {
    function InstanceStorage() {
        this.instances = [];
        this.instancesByElement = new Map();
    }
    InstanceStorage.prototype.all = function () {
        return this.instances.slice();
    };
    InstanceStorage.prototype.push = function (instance) {
        this.instances.push(instance);
        if ((0, components_1.isComponent)(instance)) {
            this.instancesByElement.set(instance, instance);
        }
    };
    InstanceStorage.prototype.remove = function (instance) {
        var index = this.instances.indexOf(instance);
        if (index !== -1) {
            this.instances.splice(index, 1);
        }
        if ((0, components_1.isComponent)(instance)) {
            this.instancesByElement.delete(instance);
        }
    };
    InstanceStorage.prototype.findByElement = function (el) {
        // TODO: is this defunct?
        var r = this.instancesByElement.get(el) || null;
        if (r) {
            return r;
        }
        if (!(0, components_1.isComponent)(el) || !el.isConnected) {
            return r;
        }
        this.push(el);
        return el;
    };
    return InstanceStorage;
}());
exports.InstanceStorage = InstanceStorage;
//# sourceMappingURL=storage.js.map